export const FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST = 'FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST';

export const findProcessStatementCommentVisibilityRequest = () => ({
    type: FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST,
});
